import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://kernected.org";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_ndis-support-hub-4/artifacts/3r31q55x_kernected%20logo%202.png";

/**
 * Per-page SEO tags. Path should start with '/' (e.g. '/about').
 */
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | Kernected Disability Support Services`
    : "Kernected Disability Support Services | NDIS Support Coordination";

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_AU" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
